/** Track duration for cards: 'm:ss', or 'h:mm:ss' for an hour and up. */
export function formatDuration(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / 3600);
  if (hours > 0) return `${hours}:${String(minutes).padStart(2, '0')}:${seconds}`;
  return `${minutes}:${seconds}`;
}

/** Coarse recency ('just now' / '5m ago' / '2h ago' / '3d ago') from an epoch-ms timestamp. */
export function formatRelativeTime(ms: number): string {
  const minutes = Math.floor((Date.now() - ms) / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

/** When a friend sang, the way you would say it: 'Today', 'Last night', a
 * weekday inside the last week, else '9 Aug'. */
export function formatDayLabel(ms: number, now = new Date()): string {
  const day = new Date(ms);
  const startOf = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const daysAgo = Math.round((startOf(now) - startOf(day)) / 86_400_000);
  if (daysAgo <= 0) return 'Today';
  if (daysAgo === 1) return 'Last night';
  if (daysAgo < 7) return day.toLocaleDateString('en-GB', { weekday: 'long' });
  return day.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

/** 'Oct 4', for a renewal beside a price. */
export function formatRenewalDate(ms: number): string {
  return new Date(ms).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/** '4 October', for a date in a sentence. */
export function formatLongDate(ms: number): string {
  return new Date(ms).toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });
}

/** '4 Oct 2026', for a date that stands alone in a table. */
export function formatDateWithYear(ms: number): string {
  return new Date(ms).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

/** '04 Sep', the date column of a receipt. */
export function formatReceiptDate(ms: number): string {
  return new Date(ms).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
}

/** '9:40 pm', when a pass runs out tonight. */
export function formatClockTime(ms: number): string {
  return new Date(ms).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }).toLowerCase();
}
